// src/components/organisms/Footer/Footer.tsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function Footer() {
  const { pathname } = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  // PC에서는 항상, 모바일에서는 오직 /mypage 경로일 때만 보여주기
  if (isMobile && pathname !== '/mypage') {
    return null;
  }

  return (
    <footer className="flex justify-center w-full px-10 py-5 mx-auto bg-gray-50">
      <div className="max-w-[1280px] w-full flex flex-col gap-2 items-center text-gray-500 text-sm">
        <div className="flex justify-center gap-8">
          <p>주식회사 알파영어</p>
          <p>사업자등록번호 5458802339</p>
          <p>대표 이광식</p>
        </div>
        <div className="flex justify-center gap-8">
          <p>통신판매업 신고 2019-서울양천-1282호</p>
          <p>
            <button>사업자 정보 확인</button>
          </p>
        </div>
        <div className="flex justify-center gap-8">
          <p>전화 01032035985</p>
          <p>주소 서울 양천구 중앙로23길 32 씨엘프라자 9층</p>
        </div>
        <p className="pt-3 text-xs text-gray-400">
          © Copyright 2024 Alpha English All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}